import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
const firebaseConfig = {
    apiKey: "AIzaSyD970X_HFzDZkY5lBcl7ADiLieW3oUr5uY",
    authDomain: "expertminute-net.firebaseapp.com",
    databaseURL: "https://expertminute-net-default-rtdb.firebaseio.com",
    projectId: "expertminute-net",
    storageBucket: "expertminute-net.appspot.com",
    messagingSenderId: "449633842774",
    appId: "1:449633842774:web:870eb23a00f98533686df7",
    measurementId: "G-BB7P76HV3P"
  };
 const app= initializeApp(firebaseConfig);
 export const firestore=getFirestore(app)
 export const auth=getAuth(app);